var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useTheme } from '../../../theme';
import { autoPlacement, offset, size, useFloating } from '@floating-ui/react';
import { Box } from '../../elements/layout/Box';
import { useUniqueId } from '../../providers/uniqueIds';
import { Z_INDEX } from '../../../theme/custom';
import { COLOR } from '../../../theme/colors';
export const Overlay = (props) => (_jsx(Box, Object.assign({}, props, { sx: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: Z_INDEX.ELEVATED,
    } })));
export const Dropdown = (_a) => {
    var { renderAnchor, renderDropdown, matchWidth, shouldRenderDropdownContainer = true, allowedPlacements = ['top-start', 'bottom-start', 'top-end', 'bottom-end'] } = _a, rest = __rest(_a, ["renderAnchor", "renderDropdown", "matchWidth", "shouldRenderDropdownContainer", "allowedPlacements"]);
    const [isOpen, setIsOpen] = useState(false);
    const [dropdownMinWidth, setDropdownMinWidth] = useState('0px');
    const [dropdownMaxWidth, setDropdownMaxWidth] = useState();
    const dropdownId = useUniqueId('dropdown');
    const anchorId = useUniqueId('dropdown-anchor');
    const { boxShadow } = useTheme();
    const { refs, floatingStyles } = useFloating({
        placement: 'bottom-start',
        middleware: [
            offset(2),
            size({
                apply({ rects }) {
                    setDropdownMinWidth(`${rects.reference.width}px`);
                    if (matchWidth) {
                        setDropdownMaxWidth(`${rects.reference.width}px`);
                    }
                },
            }),
            autoPlacement({
                allowedPlacements,
            }),
        ],
    });
    const dropdownBoxStyles = Object.assign(Object.assign({}, floatingStyles), { minWidth: dropdownMinWidth, maxWidth: dropdownMaxWidth, zIndex: Z_INDEX.DIALOG, backgroundColor: COLOR.WHITE, boxShadow: boxShadow === null || boxShadow === void 0 ? void 0 : boxShadow.NORMAL });
    const onClick = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);
    const dropdownAnchorProps = useMemo(() => ({
        id: anchorId,
        'aria-haspopup': true,
        'aria-expanded': isOpen,
        'aria-owns': dropdownId,
        ref: refs.setReference,
        onClick,
    }), [refs, onClick, anchorId, isOpen, dropdownId]);
    return (_jsxs(Box, Object.assign({}, rest, { children: [renderAnchor({
                anchorProps: dropdownAnchorProps,
                isOpen,
                setIsOpen,
            }), isOpen && (_jsxs(_Fragment, { children: [shouldRenderDropdownContainer ? (_jsx(Box, Object.assign({ id: dropdownId, ref: refs.setFloating, style: dropdownBoxStyles }, { children: renderDropdown({
                            styles: dropdownBoxStyles,
                            ref: refs.setFloating,
                            setIsOpen,
                            isOpen,
                            id: dropdownId,
                        }) }))) : (renderDropdown({
                        styles: dropdownBoxStyles,
                        ref: refs.setFloating,
                        isOpen,
                        setIsOpen,
                        id: dropdownId,
                    })), _jsx(Overlay, { onClick: () => setIsOpen(false) })] }))] })));
};
